import React from 'react';

import { Stack, Typography, Tooltip, PublicIcon } from '@gogame/components';

const Header = ({ title, subTitle, description, filters, globalPeriod }) => (
  <Stack direction={'row'} justifyContent={'space-between'} zeroMinWidth={true}>
    <Stack zeroMinWidth={true}>
      <Stack
        direction={'row'}
        spacing={1}
        zeroMinWidth={true}
        alignItems={'center'}
      >
        <Typography variant={'subtitle1'} noWrap={true} data-cy={'widgetName'}>
          <b>{subTitle}</b>
        </Typography>

        {filters}
      </Stack>

      <Stack direction={'row'} alignItems={'center'} spacing={0.5}>
        <Typography
          data-cy={'widgetType'}
          variant={'caption'}
          color={'textSecondary'}
        >
          {title}
        </Typography>

        <Typography variant={'caption'} color={'textSecondary'}>
          {' | '}
        </Typography>

        <Typography
          data-cy={'widgetDescription'}
          variant={'caption'}
          color={'textSecondary'}
          noWrap={true}
        >
          {description}
        </Typography>

        {globalPeriod ? (
          <Tooltip title={'Public'}>
            <PublicIcon sx={{ fontSize: 12 }} color={'action'} />
          </Tooltip>
        ) : null}
      </Stack>
    </Stack>
  </Stack>
);

export default Header;
